export default "__VITE_ASSET__V2fPiuB3__"